import React, { useMemo } from "react"
import map from "lodash/map"
import { I18n } from "utils/i18n-shim"
import useLocale from "hooks/useLocale"
import Autocomplete from "components/Autocomplete/Autocomplete"

/**
 *
 * @param {object} props
 * @param {string} props.i18nKey
 */
const LocalI18nAutocomplete = ({ i18nKey, ...rest }) => {
  const locale = useLocale()

  // `label` isn't displayed (getOptionLabel is); the menu sizes its width from it.
  const dataSource = useMemo(
    () =>
      map(I18n.t(i18nKey), (label, value) => ({
        label: label,
        value: value
      })),
    // The labels are translated when built, so a language switch has to rebuild them.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18nKey, locale]
  )

  return (
    <Autocomplete
      dataSource={dataSource}
      getOptionLabel={(option) => I18n.t(`${i18nKey}.${option.value}`)}
      {...rest}
    />
  )
}

export default LocalI18nAutocomplete
